import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";

const BizServePortalCTA = () => {
  return (
    <section className="py-16 px-4 bg-section">
      <div className="max-w-4xl mx-auto">
        <Card className="border-none shadow-xl">
          <CardContent className="p-8 md:p-12 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              Start Your Business with BizServe Today
            </h2>
            <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
              Join thousands of successful entrepreneurs who trust BizServe to
              handle their business needs. Get started in minutes and see the
              difference an integrated platform can make.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Button size="lg" className="text-lg px-8 py-3">
                Get Started Free
              </Button>
              <Button size="lg" variant="outline" className="text-lg px-8 py-3">
                Schedule Demo
              </Button>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-muted-foreground">
              <span className="flex items-center gap-2">✓ No setup fees</span>
              <span className="flex items-center gap-2">
                ✓ 30-day free trial
              </span>
              <span className="flex items-center gap-2">
                ✓ Expert support included
              </span>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default BizServePortalCTA;
